import React from 'react'
import './Footer.css'
import { Link as ScrollLink } from 'react-scroll';


 function Footer() {
   return (
     <>
         <div className="footer">
             <div className='footer_all'>
                 <div className='footer_1'>
                     <img src='Le_logo.png' alt='1'/>
                     <img src='logo_habous.png' alt='1'/>
                 </div>
             </div>
             <br></br>
             <div  className='footer_2'>
                 <div className='row1'>
                 <ScrollLink to="goals" smooth={true} duration={500} className="Contact-lien">
                  <p>الأهداف </p>  
                </ScrollLink> 
                <ScrollLink to="details" smooth={true} duration={500} className="Contact-lien">
                <p> تفاصيل المشروع </p>
                </ScrollLink> 
                <ScrollLink to="details" smooth={true} duration={500} className="Contact-lien">
                    <p>  تكلفة المشروع </p>
                </ScrollLink> 
                <ScrollLink to="Home" smooth={true} duration={500} className="Contact-lien">
                 <p> الرئيسية </p>
                </ScrollLink> 
                 </div>
                 <br></br>
                 <div className='row2'>
                    <ScrollLink to="Contact" smooth={true} duration={500} className="Contact-lien">
                        <p> تواصل معنا </p>
                    </ScrollLink>
                    <ScrollLink to="donate" smooth={true} duration={500} className="Contact-lien">
                        <p>تبرع</p>
                     </ScrollLink>
                 </div>
             </div>
             <br></br>
         </div>
         
     </>
   )
 }
 
 export default Footer





// import React from 'react'
// import { Link as ScrollLink } from 'react-scroll';
// import './Footer.css'
// function Footer() {
//   return (
//     <>
//         <div className="footer">
//             <div className='footer_all'>
//                 <div className='footer_1'>
//                     <img src='Groupe_10.png' alt='dar lkbira' />
//                 </div>
//                 <div  className='footer_2'>
//                     <div className='row1'>
//                         <ScrollLink to="Contact" smooth={true} duration={500} className="Contact-lien">
//                             <strong>تواصلوا معنا</strong>
//                         </ScrollLink>
//                         <ScrollLink to="donate" smooth={true} duration={500} className="Contact-lien">
//                             <strong>للتبرع</strong>
//                         </ScrollLink>
//                         <ScrollLink to="Details" smooth={true} duration={500} className="Contact-lien">
//                             <strong>تفاصيل المشروع</strong>
//                         </ScrollLink>
//                         <ScrollLink to="Home" className="Contact-lien">
//                             <strong>الرئيسية</strong>
//                         </ScrollLink>
//                     </div>
//                     <div className='row2'>
//                         <ScrollLink to="Contact" smooth={true} duration={500} className="Contact-lien">
//                             <strong>تواصلوا معنا</strong>
//                         </ScrollLink>
//                         <ScrollLink to="donate" smooth={true} duration={500} className="Contact-lien">
//                             <strong>للتبرع</strong>
//                         </ScrollLink>
//                     </div>
//                 </div>
//             </div>
//             <br></br>
                
//             {/* <div  className='footer_2'>
//                 <div className='row1'>
//                     <p> الأهداف </p>
//                     <p>  تفاصيل المشروع </p>
//                     <p> تكلفة المشروع </p>
//                     <p> الرئيسية </p>
//                 </div>
//                 <br></br>
//                 <div className='row2'>
//                     <p> تواصل معنا </p>
//                     <p>تبرع</p>
//                 </div>
//             </div> */}
//             <br></br>
//         </div>
        
//     </>
//   )
// }

// export default Footer